var _path, _rect, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H42C45.3137 0 48 2.68629 48 6V42C48 45.3137 45.3137 48 42 48H6C2.68629 48 0 45.3137 0 42V6Z",
    fill: "#B0D7EF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 48,
    height: 48,
    fill: "#7CA6C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15V13C40 11.8954 39.1046 11 38 11H10C8.89543 11 8 11.8954 8 13V15C8 16.1046 8.89543 17 10 17H38C39.1046 17 40 16.1046 40 15Z",
    fill: "#DAEDF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25V23C30 21.8954 29.1046 21 28 21H10C8.89543 21 8 21.8954 8 23V25C8 26.1046 8.89543 27 10 27H28C29.1046 27 30 26.1046 30 25Z",
    fill: "#DAEDF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35V33C34 31.8954 33.1046 31 32 31H10C8.89543 31 8 31.8954 8 33V35C8 36.1046 8.89543 37 10 37H32C33.1046 37 34 36.1046 34 35Z",
    fill: "#DAEDF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d769599b.svg";
export { ForwardRef as ReactComponent };